
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class PurchaseItemsSelectGrid extends _Ext.GridBase<PurchaseItemsRow, any> {
        protected getColumnsKey() { return 'Purchase.PurchaseItemsSelect'; }
        protected getDialogType() { return <any>PurchaseItemsDialog; }
        protected getIdProperty() { return PurchaseItemsRow.idProperty; }
        protected getLocalTextPrefix() { return PurchaseItemsRow.localTextPrefix; }
        protected getService() { return PurchaseSelectItemsService.baseUrl; } 
       
        constructor(container: JQuery,options) {
            super(container, options);
            var partyid = parseInt(options.GridFilters.PartyId);
            if (partyid != null && partyid > 0)
                (this.view.params as TransactionRequest).PartyId = partyid;
             
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }

        private autoSize;
 
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): PurchaseItemsRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return true; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false; 
            return true;

        }

    }
     
}